import { Checkbox as NovaBaseCheckbox, CheckboxProps as NovaCheckboxProps } from '@fme-nova/components'
import { CheckboxProps as MuiCheckboxProps, default as MuiBaseheckbox } from '@mui/material/Checkbox'

import { COLORS, createComponentWrapperWithRef, styled, uiTokens } from '../../theme'

type CheckboxProps = Omit<MuiCheckboxProps & NovaCheckboxProps, 'ref'>

const MuiCheckbox = styled(MuiBaseheckbox)`
  color: ${COLORS.text.secondary};

  &:hover {
    background-color: ${COLORS.primary.hover};
  }

  &:disabled {
    background-color: ${COLORS.text.disabled};
  }

  &.Mui-checked {
    color: ${COLORS.primary.main};
  }
`

const NovaCheckbox = styled(NovaBaseCheckbox)`
  color: ${uiTokens.uiControl.contained.enabled};

  &:disabled {
    background-color: ${uiTokens.uiContent.disabled};
  }

  &:hover {
    background-color: ${uiTokens.uiSurface.hover};
  }
`

export const Checkbox = createComponentWrapperWithRef<CheckboxProps>(
  {
    mui: MuiCheckbox,
    nova: NovaCheckbox,
  },
  'Checkbox',
)
